import React from 'react';

import { BACKEND_URL } from './apiBase';
import './Modal.css';

interface ModalProps {
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ onClose }) => {
  const openInNewTab = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          &times;
        </button>

        <h2>Example Applications</h2>
        <div className="grid-container">

          <button className="grid-item" onClick={() => openInNewTab('https://digest.blueskyengineering.net')}>
            Daily Digest
            <img src="/app_images/preview_daily_digest.png" alt="Daily Digest" />
          </button>


          <button className="grid-item" onClick={() => openInNewTab('https://intel-mining.blueskyengineering.net')}>
            Airbnb Market Intel
            <img src="/app_images/preview_intel_mining.png" alt="Airbnb Market Intel" />
          </button>


          <button className="grid-item" onClick={() => openInNewTab('https://home-monitoring.blueskyengineering.net')}>
            Home Monitoring
            <img src="/app_images/preview_home_monitoring.png" alt="Home Monitoring" />
          </button>


          <button className="grid-item" onClick={() => openInNewTab(`${BACKEND_URL}/app_agentic_solution_generator`)}>
            Agentic Solution Generator
            <img src="/app_images/preview_agentic_solution_pattern_generator.png" alt="Agentic Solution Generator" />
          </button>


          <button className="grid-item" onClick={() => openInNewTab('https://job-search.blueskyengineering.net')}>
            Job Search Agent
            <img src="/app_images/preview_job_search.png" alt="Job Search Agent" />
          </button>


          <button className="grid-item" onClick={() => openInNewTab(`${BACKEND_URL}/app_jupyter_notebook_generator`)}>
            Jupyter Notebook Generator
            <img src="/app_images/preview_jupyter_notebook_generator.png" alt="Jupyter Notebook Generator" />
          </button>


          <button className="grid-item" onClick={() => openInNewTab('https://turbo-game.blueskyengineering.net')}>
            Turbo: Lost & Found
            <img src="/app_images/preview_turbo_game.png" alt="Turbo: Lost & Found" />
          </button>


          <button className="grid-item" onClick={() => openInNewTab('https://petpals.blueskyengineering.net')}>
            PetPals
            <img src="/app_images/preview_petpals.png" alt="PetPals" />
          </button>


          <button className="grid-item" onClick={() => openInNewTab('https://coloring-book.blueskyengineering.net')}>
            AI Coloring Books
            <img src="/app_images/preview_coloring_book.png" alt="AI Coloring Books" />
          </button>


          <button className="grid-item" onClick={() => openInNewTab('https://github.com/mcrockett86/hugging_face_agents_project')}>
            GAIA Challenge
            <img src="/app_images/preview_gaia_challenge.png" alt="GAIA Challenge" />
          </button>


          <button className="grid-item" onClick={() => openInNewTab(`${BACKEND_URL}/app_cover_letter_generator`)}>
            Cover Letter Generator
            <img src="/app_images/preview_cover_letter_generator.png" alt="Cover Letter Generator" />
          </button>


          <button className="grid-item" onClick={() => openInNewTab('https://www.youtube.com/watch?v=rJ8JY122xiE')}>
            Guerilla Marketing
            <img src="/app_images/preview_guerilla_marketing.png" alt="Guerilla Marketing" />
          </button>


          <button className="grid-item" onClick={() => openInNewTab('/app_content/RAPID_FINAL.pdf')}>
            Manufacturing Systems
            <img src="/app_images/preview_manufacturing_analysis.png" alt="Manufacturing Systems" />
          </button>


          {/* Hidden by request — kept for future revival.
          <button className="grid-item" onClick={() => openInNewTab(`${BACKEND_URL}/app_real_estate_prospecting`)}>
            Real Estate Prospecting
            <img src="/app_images/preview_real_estate_prospecting.png" alt="App 5" />
          </button>

          <button className="grid-item" onClick={() => openInNewTab(`${BACKEND_URL}/app_edge_ai_tracking`)}>
            Edge AI Object Detection
            <img src="/app_images/preview_app_edge_ai_tracking.png" alt="App 6" />
          </button>
          */}

          {/*
          <button className="grid-item" onClick={() => openInNewTab('https://example.com')}>
            App 7
            <img src="https://via.placeholder.com/150" alt="App 7" />
          </button>
          <button className="grid-item" onClick={() => openInNewTab('https://example.com')}>
            App 8
            <img src="https://via.placeholder.com/150" alt="App 8" />
          </button>
          <button className="grid-item" onClick={() => openInNewTab('https://example.com')}>
            App 9
            <img src="https://via.placeholder.com/150" alt="App 9" />
          </button>
          */}
        </div>
      </div>
    </div>
  );
};

export default Modal;
